import { render, staticRenderFns } from "./CmsList.vue?vue&type=template&id=513de6af&scoped=true"
import script from "./CmsList.vue?vue&type=script&lang=js"
export * from "./CmsList.vue?vue&type=script&lang=js"
import style0 from "./CmsList.vue?vue&type=style&index=0&id=513de6af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513de6af",
  null
  
)

export default component.exports